module.exports = __webpack_public_path__ + "img/collection-weddingRingsNaturalBeige@2x.2d852e1.jpg";